import type { Cache, UpdatesConfig } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type {
  RentersInterestedPartyCreateMutation,
  RentersInterestedPartyCreateMutationVariables,
  RentersInterestedPartyDeleteMutation,
  RentersInterestedPartyDeleteMutationVariables,
  RentersInterestedPartyUpdateMutation,
  RentersInterestedPartyUpdateMutationVariables,
} from '@/graphql/generated/graphql';

const invalidateSkypadPolicyUnique = (
  cache: Cache,
  policyNumber: string,
) => {
  invalidateQuery('skypadPolicyUnique', cache, {
    policy_number: policyNumber,
  });
};

const rentersInterestedParty: UpdatesConfig['Mutation'] = {
  rentersInterestedPartyCreate: (
    _data: RentersInterestedPartyCreateMutation,
    variables: RentersInterestedPartyCreateMutationVariables,
    cache: Cache,
  ) => {
    invalidateSkypadPolicyUnique(cache, variables.policy_number);
  },
  rentersInterestedPartyUpdate: (
    _data: RentersInterestedPartyUpdateMutation,
    variables: RentersInterestedPartyUpdateMutationVariables,
    cache: Cache,
  ) => {
    invalidateSkypadPolicyUnique(cache, variables.policy_number);
  },
  rentersInterestedPartyDelete: (
    _data: RentersInterestedPartyDeleteMutation,
    variables: RentersInterestedPartyDeleteMutationVariables,
    cache: Cache,
  ) => {
    invalidateSkypadPolicyUnique(cache, variables.policy_number);
  },
};

export default rentersInterestedParty;
